import React from 'react';
import PaymentSuccessContainer from '../../../Containers/UserContainer/PaymentSuccess';

const PaymentSuccessScreen = () => {
  return <PaymentSuccessContainer />;
};

export default PaymentSuccessScreen;
